(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["horizontal-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    function initHorizontalSlider(section) {
      if (!section) return;

    const carousel = section.querySelector('.horizontal-slider__carousel');
    const track = section.querySelector('.horizontal-slider__track');
    const slides = section.querySelectorAll('.horizontal-slider__slide');
    const prevButton = section.querySelector('[data-prev]');
    const nextButton = section.querySelector('[data-next]');
    const intervalAttr = section.getAttribute('data-carousel-interval');
    const interval = intervalAttr ? parseInt(intervalAttr, 10) : 5000;

    if (!carousel || !track || slides.length === 0) return;

    let currentIndex = 0;
    let autoPlayInterval = null;
    let isPaused = false;
    let isManualPause = false;

    function getVisibleSlides() {
      const carouselWidth = carousel.offsetWidth;
      const slideWidth = slides[0].offsetWidth;
      const gap = 16;
      return Math.floor((carouselWidth + gap) / (slideWidth + gap));
    }

    function updateCarousel() {
      const visibleSlides = getVisibleSlides();
      const slideWidth = slides[0].offsetWidth;
      const gap = 16;
      const maxIndex = Math.max(0, slides.length - visibleSlides);
      
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }

      const translateX = -(currentIndex * (slideWidth + gap));
      track.style.transform = `translateX(${translateX}px)`;
      
      updateButtons();
    }

    function updateButtons() {
      const visibleSlides = getVisibleSlides();
      const maxIndex = Math.max(0, slides.length - visibleSlides);
      
      if (prevButton) {
        prevButton.disabled = currentIndex === 0;
      }
      
      if (nextButton) {
        nextButton.disabled = currentIndex >= maxIndex;
      }
    }

    function nextSlide() {
      const visibleSlides = getVisibleSlides();
      const maxIndex = Math.max(0, slides.length - visibleSlides);
      
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    }

    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }

    function startAutoPlay() {
      if (isManualPause || isPaused) return;
      
      stopAutoPlay();
      
      if (interval > 0 && slides.length > getVisibleSlides()) {
        autoPlayInterval = setInterval(function() {
          if (isManualPause || isPaused) return;
          
          const visibleSlides = getVisibleSlides();
          const maxIndex = Math.max(0, slides.length - visibleSlides);
          
          if (currentIndex >= maxIndex) {
            currentIndex = 0;
          } else {
            currentIndex++;
          }
          
          updateCarousel();
        }, interval);
      }
    }

    function stopAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    }

    function pauseAutoPlay() {
      isPaused = true;
      stopAutoPlay();
    }

    function resumeAutoPlay() {
      isPaused = false;
      isManualPause = false;
      startAutoPlay();
    }

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        prevSlide();
        isManualPause = true;
        stopAutoPlay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        nextSlide();
        isManualPause = true;
        stopAutoPlay();
      });
    }

    carousel.addEventListener('mouseenter', pauseAutoPlay);
    carousel.addEventListener('mouseleave', resumeAutoPlay);

    carousel.addEventListener('focusin', function(e) {
      if (carousel.contains(e.target)) {
        pauseAutoPlay();
      }
    });

    carousel.addEventListener('focusout', function(e) {
      if (!carousel.contains(e.relatedTarget)) {
        resumeAutoPlay();
      }
    });

    function handleResize() {
      updateCarousel();
    }

    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 250);
    });

    function init() {
      updateCarousel();
      startAutoPlay();
    }

    init();

    return {
      destroy: function() {
        stopAutoPlay();
      }
    };
  }

    const sections = document.querySelectorAll('[data-section-type="horizontal-slider"]');
    const instances = new Map();

    sections.forEach(function(section) {
      const instance = initHorizontalSlider(section);
      if (instance) {
        instances.set(section.dataset.sectionId, instance);
      }
    });

    document.addEventListener('shopify:section:load', function(e) {
      const targetSection = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
      if (targetSection && targetSection.dataset.sectionType === 'horizontal-slider') {
        setTimeout(function() {
          const instance = initHorizontalSlider(targetSection);
          if (instance) {
            instances.set(e.detail.sectionId, instance);
          }
        }, 100);
      }
    });

    document.addEventListener('shopify:section:unload', function(e) {
      const instance = instances.get(e.detail.sectionId);
      if (instance) {
        instance.destroy();
        instances.delete(e.detail.sectionId);
      }
    });

    document.addEventListener('shopify:section:select', function(e) {
      const targetSection = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
      if (targetSection && targetSection.dataset.sectionType === 'horizontal-slider') {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    document.addEventListener('shopify:block:select', function(e) {
      const targetSection = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
      if (targetSection && targetSection.dataset.sectionType === 'horizontal-slider') {
        const carousel = targetSection.querySelector('.horizontal-slider__carousel');
        const track = targetSection.querySelector('.horizontal-slider__track');
        const slides = targetSection.querySelectorAll('.horizontal-slider__slide');
        
        if (carousel && track && slides.length > 0) {
          const blockIndex = parseInt(e.detail.blockId.match(/\d+$/)?.[0]) || 0;
          const slideWidth = slides[0].offsetWidth;
          const gap = 16;
          const carouselWidth = carousel.offsetWidth;
          const visibleSlides = Math.floor((carouselWidth + gap) / (slideWidth + gap));
          const maxIndex = Math.max(0, slides.length - visibleSlides);
          const currentIndex = Math.min(blockIndex, maxIndex);
          const translateX = -(currentIndex * (slideWidth + gap));
          
          track.style.transform = 'translateX(' + translateX + 'px)';
        }
        
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
